var render, staticRenderFns
import script from "./TrainingsAssistant.vue?vue&type=script&lang=js"
export * from "./TrainingsAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/honeypot.learningsystem.de/releases/20260624084000/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2daff9a0')) {
      api.createRecord('2daff9a0', component.options)
    } else {
      api.reload('2daff9a0', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/TrainingsAssistant.vue"
export default component.exports